import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { useAuth } from "../../context/AuthContext";
import "./AdminLogin.css";

function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { loginSuperAdmin, auth, isSuperAdmin } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (auth && isSuperAdmin) navigate("/admin", { replace: true });
  }, [auth, isSuperAdmin, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !password) {
      toast.error("Email and password required");
      return;
    }
    setLoading(true);
    try {
      await loginSuperAdmin(email.trim(), password);
      toast.success("Logged in");
      navigate("/admin");
    } catch (err) {
      toast.error(err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-card">
        <h1>Super Admin</h1>
        <p>Manage venues and analytics</p>
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
          />
          <button type="submit" disabled={loading}>
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
        <p className="admin-login-hint">
          First login creates the super admin account.
        </p>
      </div>
    </div>
  );
}

export default AdminLogin;
